<template>
  <div>
    <div class="storebox">
      <div class="storeboxl">
        <div class="ckszbox">
          <h3>串口设置</h3>
          <div class="ckszboxnr">
            <span class="title">串口号</span>
            <div>
              <h3 style="cursor: pointer" @click.stop="flag2 = !flag2">
                {{ ckh }}
              </h3>
              <span
                class="clan"
                style="cursor: pointer"
                @click.stop="flag2 = !flag2"
                ><img
                  :class="{ active: flag2 }"
                  src="../../assets/工厂测试_slices/Polygon1.png"
                  alt=""
              /></span>
            </div>

            <ul class="xzq" v-if="flag2">
              <li
                v-for="(item, index) in list"
                :key="index"
                style="cursor: pointer"
                @click.stop="change(item)"
              >
                {{ item }}
              </li>
            </ul>
 <div class="dkzt">{{ dkorgb }}</div>
          </div>

        </div>
        <div class="dkan" >
         <div style="cursor: pointer"  @click="OpenPort">打开</div>
         <div style="cursor: pointer"  @click="ClosePort">关闭</div>
        </div>

        <div class="zjjc">
          <h3>整机检测</h3>
          <div>
            <div>
              <span @click="CheckJigou">机构检测</span>
              <div>
                <li>
                  <div>电机1:<span>{{portDataDianJi1}}</span></div>
                  <div class="leftbox">电机2:<span>{{portDataDianJi2}}</span></div>
                </li>
                <li>
                  <div>电机3:<span>{{portDataDianJi3}}</span></div>
                  <div class="leftbox">电机4:<span>{{portDataDianJi4}}</span></div>
                </li>
                <li>
                  <div>光线强度:<span>{{portDataLight}}</span></div>
                  <div class="leftbox">距离:<span>{{portDataDistance}}</span></div>
                </li>
              </div>
            </div>
            <div>
              <span @click="CheckVoice">语音检测</span>
            </div>
          </div>
        </div>
        <div class="diopterbox">
          <h3>设置屈光度</h3>
          <div>
           <li>
              <div>
                <span>屈光度</span
                ><input placeholder="请输入屈光度" v-model="serverDiopter" type="text" />
              </div>
              <span @click="SetDiopter">设置</span>
            </li>
          </div>
        </div>
      </div>

      <div class="storeboxr">
        <div class="sjjsbox">
          <h3>串口数据接收<span class="back" @click="Quit">退出</span></h3>
          <div>
            <p><span class="time">时间</span><span class="hy">回应</span></p>
            <div ref="portMsgBox">
              <li v-for="(item,index) in portDataList" :class="{portMsgcolor:item.colour==2 }" :key="index">
                <span class="time">{{item.time}}</span><span>{{item.rv}}</span>
              </li>
            </div>
          </div>
        </div>
        <div class="ccsz">
          <h3>出厂设置</h3>
          <div>
            <li>
              <div>
                <span>SN码</span
                ><input placeholder="请输入SN码" v-model="sn" type="text" />
              </div>
              <span @click="SetSn">设置</span>
            </li>
            <div>
              <el-steps :active="bznum" align-center finish-status="success">
                <el-step title="步骤1" description="设置SN码"></el-step>
                <el-step title="步骤2" description="获取芯片ID"></el-step>
                <el-step title="步骤3" description="设置授权码"></el-step>
                <el-step title="步骤4" description="清空用户ID"></el-step>
              </el-steps>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      bznum:-1,
      list: [],
      portDataList: [], // 串口数据
      ckh: 'COM1',
      flag2: false,
      dkorgb: '---',
      diopter: '',
      serialnum: '',
      voiceList:[
        {index:1,msg:'电量不足，请充电'},
      	{index:2,msg:'余额不足，请充值'},
      	{index:3,msg:'操作完成'},
      	{index:4,msg:'请连接APP重新登录'},
      	{index:5,msg:'设备故障'},
      	{index:6,msg:'请联系客服'},
      	{index:7,msg:'自动校准，请不要摘下眼镜'},
      	{index:8,msg:'校准失败'},
      	{index:9,msg:'如有不适，请在APP上点击干预'},
      	{index:10,msg:'效果音“叮”'},
      	{index:11,msg:'测试语音'},
      	{index:12,msg:'请调整坐姿'},
      	{index:13,msg:'请注意用眼距离'},
      	{index:14,msg:'训练完成'},
      	{index:15,msg:'请休息一下吧'},
      	{index:16,msg:'请及时连接APP上传数据'},
      	{index:17,msg:'效果音“叮咚”'},
      	{index:18,msg:'已训练 30 分钟'},
      	{index:19,msg:'已训练 60 分钟'},
      	{index:20,msg:'已训练 90 分钟'},
      	{index:21,msg:'今日训练完成'},
      	{index:22,msg:'请停止佩戴'},
      	{index:23,msg:'保持合理用眼距离'}
      ],
      //
      ua: 'ua',
      portDataDianJi1: '',
      portDataDianJi2: '',
      portDataDianJi3: '',
      portDataDianJi4: '',
      portDataLight: '',
      portDataDistance: '',
      portDataCurRangeIndex: '',
      cpuId: '',
      serverUserId: '00000000',
      deviceUserId: '',
      userTime: '',
      deviceTime: '',
      vol: '',
      //
      serverDiopter: 0,
      deviceDiopter: '',
      sn: '',
      aCodeResult: ''
    }
  },
  methods: {
    change (name) {
      this.ckh = name
      this.flag2 = false
    },
    /// /////
    // 打开串口
    OpenPort () {
      this.dkorgb = window.external.OpenPort(this.ckh)
    },
    // 关闭串口
    ClosePort () {
      this.dkorgb = window.external.ClosePort()
    },
    // 心跳包
    HeartbeatPackets () {
      window.external.WritePortData('240D010101')
    },
    // 机构检测
    CheckJigou () {
      window.external.WritePortData('240A010101')
    },
    // 语音检测
    CheckVoice () {
      window.external.WritePortData('240C010101')
    },
    // 询问当前区间
    QueryCurRange () {
      window.external.WritePortData('2405010101')
    },
    // 设置用户ID
    SetUserId () {
      var data = '240104' + this.serverUserId + '00'
      window.external.WritePortData(data)
    },
    // 查询用户ID
    QueryUserId () {
      window.external.WritePortData('2404010101')
    },
    // 设置屈光度
    SetDiopter () {
      if (this.serverDiopter <= 100 && this.serverDiopter >= -300) {
        var hex = window.external.IntToHexStr(this.serverDiopter)
        var data = '240202' + hex + '00'
        window.external.WritePortData(data)
      } else {
        Vue.prototype.FunAlertMsg('超出使用范围：+100~-300')
      }
    },
    // 查询CPU ID
    QueryCpuId () {
      window.external.WritePortData('2406010101')
    },
    // 设置授权码
    SetAuthorizationCode () {
      var crc16 = window.external.GetCrc16(this.cpuId)
      var data = '240706F802' + this.cpuId.slice(6, 7) + this.cpuId.slice(9, 11) + this.cpuId.slice(13) + crc16 + '00'
      window.external.WritePortData(data)

      this.RslEvAddCpuId(data)
    },
    // 查询使用时长
    QueryUserTime () {
      window.external.WritePortData('2408010101')
    },
    // 清空使用时长
    ClearUserTime () {
      window.external.WritePortData('2409010101')
    },
    // 设置产品设备号
    SetSn () {
      // var time = new Date()
      // // 年
      // var fullYear = '' + time.getFullYear()
      // var myYear = fullYear.slice(2)
      // // 月
      // var month = time.getMonth() + 1
      // var myMonth = '' + month
      // if (month < 10) {
      //   myMonth = '0' + month
      // }
      // // 日
      // var date = time.getDate()
      // var myDate = '' + date
      // if (date < 10) {
      //   myDate = '0' + date
      // }
      // // 处理流水号
      // var snint = parseInt(this.sn)
      // var snstr = ''
      // if (snint < 10) {
      //   snstr = '000' + snint
      // } else if (snint < 100) {
      //   snstr = '00' + snint
      // } else if (snint < 1000) {
      //   snstr = '0' + snint
      // } else {
      //   snstr = '' + snint
      // }
      // var data = '240B0602' + myYear + myMonth + myDate + snstr + '00'
      var data = '240B06' + this.sn + '00'
      window.external.WritePortData(data)
      this.bznum = 0
    },
    // 接收串口数据并处理
    RecvDataFromWinForm (data) {
      if (data.indexOf('$,') != -1 && data.indexOf(',%') != -1) {
        var dataList = data.split(',')
        var dataType = dataList[1]
        if (dataType == '1') {
          var rvType = dataList[2]
          if (rvType == '1') {
            this.AddPortDataList('设置用户ID，指令收到')
            this.bznum = 4
          }
          if (rvType == '2') {
            this.AddPortDataList('设置用户初始屈光度，指令收到')
          }
          if (rvType == '9') {
            this.AddPortDataList('清空用户使用时长，指令收到')
          }
          if (rvType == '10') {
            this.AddPortDataList('机构检测，指令收到')
          }
          if (rvType == '11') {
            this.AddPortDataList('设置产品设备号，指令收到')
            this.bznum = 1
            this.QueryCpuId()
          }
          if (rvType == '12') {
            this.AddPortDataList('语音检测，指令收到')
          }
        }
        if (dataType == '2') {
          this.deviceUserId = dataList[2] + dataList[3] + dataList[4] + dataList[5]
          this.AddPortDataList('查询用户ID，指令收到')
        }
        if (dataType == '3') {
          this.portDataDianJi1 = dataList[2]
          this.portDataDianJi2 = dataList[3]
          this.portDataDianJi3 = dataList[4]
          this.portDataDianJi4 = dataList[5]
        }
        if (dataType == '4') {
          this.portDataLight = dataList[3]
          this.portDataDistance = dataList[2]
        }
        if (dataType == '6') {
          this.portDataCurRangeIndex = dataList[2]
          this.AddPortDataList('查询区间，指令收到')
        }
        if (dataType == '7') {
          this.cpuId = dataList[2] + dataList[3] + dataList[4] + dataList[5] + dataList[6] + dataList[7] + dataList[8]
          this.AddPortDataList('芯片ID查询成功')
          this.bznum = 2
          this.SetAuthorizationCode()
        }
        if (dataType == '8') {
          this.aCodeResult = dataList[2]
          this.AddPortDataList('授权结果：' + this.aCodeResult)
          this.bznum = 3
          this.ClearUserId()
        }
        if (dataType == '9') {
          this.userTime = dataList[2]
          this.deviceTime = dataList[3]
          this.AddPortDataList('查询时长，指令收到')
        }
        if (dataType == '10') {
          this.deviceDiopter = dataList[2]
          this.AddPortDataList('屈光度：' + this.deviceDiopter)
        }
        if (dataType == '11') {
          var curIndex = parseInt(dataList[2]) - 1
          if(curIndex <= 22 && curIndex >= 0){
            this.AddPortDataListColour(this.voiceList[curIndex].msg,2)
          }
        }
        if (dataType == '12') {
          this.AddPortDataListColour('♡')
          this.HeartbeatPackets()
        }
        this.dkorgb = '已打开'
      } else if (data.indexOf('Vol:') != -1) {
        this.vol = data
        this.AddPortDataList(data)
        this.dkorgb = '已打开'
      } else if (data.indexOf('请确保眼镜开机并且连线正常') != -1) {
        this.AddPortDataList(data)
        this.dkorgb = '异常'
      } else {
        this.AddPortDataList(data)
        this.dkorgb = '已打开'
      }
    },
    AddPortDataList (msg) {
      this.AddPortDataListColour(msg,1)
    },
    AddPortDataListColour (msg,colour) {
      var d = new Date()
      var hour = d.getHours()
      hour = hour > 9 ? hour : '0' + hour.toString()
      var minute = d.getMinutes()
      minute = minute > 9 ? minute : '0' + minute.toString()
      var second = d.getSeconds()
      second = second > 9 ? second : '0' + second.toString()
      var curTime = '' + hour + ':' + minute + ':' + second
      this.portDataList.push({ time: curTime, rv: msg, colour: colour })

      var that = this
      this.$nextTick(() => {
        const portMsgBox = that.$refs.portMsgBox
        portMsgBox.scrollTop = portMsgBox.scrollHeight
      })
    },
    /// /////
    Quit () {
      Vue.prototype.QuitRslEv()
    },
    ClearUserId () {
      this.serverUserId = '00000000'
      this.SetUserId()
    },
    RslEvAddCpuId: function (acode) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        cpuid: that.cpuId,
        sn: that.sn,
        acode: acode
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignRslEv(data)
      axios.post(Vue.prototype.global.Url_RslEvAddCpuId, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    RslEvCheckLogin: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignRslEv(data)
      axios.post(Vue.prototype.global.Url_RslEvCheckLogin, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code !== 200) {
            Vue.prototype.QuitRslEv()
          }
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  },
  mounted () {
    this.RslEvCheckLogin()
    Vue.prototype.CheckRslEvKeyWord()

    document.body.addEventListener('click', () => {})

    window.RecvDataFromWinForm = this.RecvDataFromWinForm

    // 串口号
    this.list = []
    for (var i = 1; i <= 16; i++) {
      this.list.push('COM' + i)
    }
  }
}
</script>
<style scoped>
  span{
    text-align: center;
  }
h3 {
  margin: 0;
}
.storebox {
  width: 960px;

  height: 720px;
  overflow: hidden;
  display: flex;
  justify-content: space-around;
}
.storeboxr {
  width: 440px;
}
.storeboxl {
  width: 440px;
}
.ckszbox {
  position: relative;
  width: 440px;
  height: 146px;
  background: #ffffff;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
}
.ckszbox > h3 {
  height: 58px;
  text-align: left;
  text-indent: 2em;
  line-height: 58px;
  border-bottom: 1px #f1f5f6 solid;
  font-size: 19px;
  font-weight: bold;
  color: #1f216e;
  margin: 0;
}
.ckszboxnr {
  position: relative;
  margin-top: 25px;
  margin-left: 37px;
  display: flex;
  width: 215px;
  height: 37px;
  background: #e0e6ff;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  line-height: 37px;
}
.ckszboxnr > .title {
  display: block;
  width: 62px;
  height: 37px;
  font-size: 14px;
  font-weight: 500;
  color: #1f216e;
  line-height: 37px;
  text-indent: 1em;
}

.ckszboxnr > div {
  margin-left: 18px;
  margin-top: 3px;
  display: flex;
  width: 130px;
  height: 31px;
  background: #ffffff;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
}
.ckszboxnr > div > h3 {
  display: block;
  width: 155px;
  height: 37px;
  line-height: 37px;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  color: #222222;
  text-indent: 2em;
}
.ckszboxnr > .xzq {
  position: absolute;
  top: 37px;
  left: 80px;
  width: 100px;
  text-align: left;
  height: 137px;
  background: #ffffff;
  overflow: auto;
  opacity: 1;
}
.ckszboxnr > .xzq > li {
  font-size: 14px;
  font-weight: 400;
  color: #222222;
  border-bottom: 1px rgb(74, 68, 68) solid;
  text-indent: 2em;
}
.ckszboxnr > div > .clan {
  margin-top: 2px;
  width: 32px;
  height: 27px;
  background: #e0e6ff;
  border-radius: 0px 5px 5px 0px;
  opacity: 1;
  margin-right: 2px;
}
.ckszboxnr > div > .clan > img {
  display: block;
  width: 15px;
  height: 11px;
  margin-top: 8px;
  margin-left: 4px;
  transform: rotate(360deg);
  transition: all 0.5s;
}
.ckszboxnr > div > .clan > .active {
  transform: rotate(180deg);
  transition: all 0.5s;
}


.dkan {
  margin-left: 37px;
  display: flex;
  justify-content: space-between;
  width: 120px;
  height: 29px;
  opacity: 1;
  line-height: 29px;
  font-size: 14px;
}
.dkan > div {
  box-shadow: 0px 4px 25px 1px rgba(0, 20, 219, 0.12);
  border-radius: 5px 5px 5px 5px;
  width: 50px;
  height: 29px;
  opacity: 1;
  color: #000;
  text-align: center;
  line-height: 29px;
}
.ckszboxnr>.dkzt{
  position: absolute;
  top: 0;
  right: -66px;
 background:#e0e6ff;
 width: 50px;
 height: 30px;
 line-height: 30px;
 text-indent: 0.3em;
}
.zjjc {
  margin-top: 20px;
  width: 440px;
  height: 313px;
  border-radius: 5px 5px 5px 5px;
  background: #f7fbfc;
}
.zjjc > h3 {
  height: 58px;
  text-align: left;
  text-indent: 2em;
  line-height: 58px;
  border-bottom: 1px #f1f5f6 solid;
  font-size: 19px;
  font-weight: bold;
  color: #1f216e;
  background: #ffffff;
}
.zjjc > div {
  width: 390px;
  height: 203px;
  background: #ffffff;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  margin: 25px auto;
  overflow: hidden;
}
.zjjc > div > div {
  margin-top: 20px;
  display: flex;
}
.zjjc > div > div > span:hover {
  display: block;
  width: 87px;
  height: 29px;
  line-height: 29px;
  background: linear-gradient(180deg, #4254ff 0%, #63aafd 100%);
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  cursor: pointer;
}
.zjjc > div > div > span {
  display: block;
  width: 87px;
  height: 29px;
  border-radius: 5px 5px 5px 5px;
  line-height: 29px;
  border: 1px solid #dadcf7;
  opacity: 1;
  font-size: 14px;
  font-weight: 500;
  color: #2c30b6;
  cursor: pointer;
  margin-left: 25px;
}
.zjjc > div > div > div {
  width: 233px;
  height: 99px;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  border: 1px solid #dde2fa;
  margin-left: 20px;
}
.zjjc > div > div > div > li {
  display: flex;
  margin-top: 8px;
  justify-content: space-around;
}
.zjjc > div > div > div > li > div {
  width: 113px;
  text-align: left;
  font-size: 12px;
  font-weight: 500;
  color: #676887;
  height: 24px;
  line-height: 24px;
}
.zjjc > div > div > div > li > div > span {
  margin-left: 13px;
  font-size: 16px;
  font-weight: 500;
  color: #1f216e;
  line-height: 24px;
}
.zjjc > div > div > div > li > .leftbox {
  width: 80px;
}
.ccsz {
  margin-top: 20px;
  width: 440px;
  height: 200px;
  background: #ffffff;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
}
.ccsz > h3 {
  height: 58px;
  text-align: left;
  text-indent: 2em;
  line-height: 58px;
  border-bottom: 1px #f1f5f6 solid;
  font-size: 19px;
  font-weight: bold;
  color: #1f216e;
  background: #ffffff;
}
.ccsz > div > li {
  width: 368px;
  margin: 25px auto;
  display: flex;
  justify-content: space-between;
}
.ccsz > div > li > div {
  width: 271px;
  height: 37px;
  background: #e0e6ff;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  display: flex;
}
.ccsz > div > li > div > span {
  display: block;
  width: 75px;
  line-height: 37px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #1f216e;
}
.ccsz > div > li > div>input{
 width: 189px;
height: 31px;
background: #FFFFFF;
border-radius: 5px 5px 5px 5px;
opacity: 1;
border-style: none;
margin-top: 3px;
text-align: left;
text-indent: 1em;
}
.ccsz > div > li > div>input:focus{
  border: 0px;
}
.ccsz > div > li>span{
  margin-top: 2px;
display: block;
  width: 87px;
  height: 29px;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  border: 1px solid #dadcf7;
  font-size: 14px;
  font-weight: 500;
  color: #2c30b6;
  line-height: 29px;
  cursor: pointer;
}
.ccsz>div>li>span:hover{
  background: linear-gradient(180deg, #4254ff 0%, #63aafd 100%);
}

.ccsz > div > .bottombox > span {
  display: block;
  width: 87px;
  height: 29px;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  border: 1px solid #dadcf7;
  font-size: 14px;
  font-weight: 500;
  color: #2c30b6;
  line-height: 29px;
  cursor: pointer;
}
.ccsz > div > .bottombox > span:hover{
   background: linear-gradient(180deg, #4254ff 0%, #63aafd 100%);
}

.diopterbox{
  margin-top: 20px;
  width: 440px;
height: 146px;
background: #FFFFFF;
border-radius: 5px 5px 5px 5px;
opacity: 1;
}

.diopterbox>h3{
  height: 58px;
  text-align: left;
  text-indent: 2em;
  line-height: 58px;
  border-bottom: 1px #f1f5f6 solid;
  font-size: 19px;
  font-weight: bold;
  color: #1f216e;
  background: #ffffff;
}
.diopterbox > div > li {
  width: 368px;
  margin: 25px auto;
  display: flex;
  justify-content: space-between;
}

.diopterbox  > div > li > div {
  width: 271px;
  height: 37px;
  background: #e0e6ff;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  display: flex;
}
.diopterbox  > div > li > div > span {
  display: block;
  width: 75px;
  line-height: 37px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #1f216e;
}
.diopterbox  > div > li > div>input{
 width: 189px;
height: 31px;
background: #FFFFFF;
border-radius: 5px 5px 5px 5px;
opacity: 1;
border-style: none;
margin-top: 3px;
text-align: left;
text-indent: 1em;
}
.diopterbox  > div > li > div>input:focus{
  border: 0px;
}
.diopterbox  > div > li>span{
  margin-top: 2px;
display: block;
  width: 87px;
  height: 29px;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  border: 1px solid #dadcf7;
  font-size: 14px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #2c30b6;
  line-height: 29px;
  cursor: pointer;
}
.diopterbox>div>li>span:hover{
  background: linear-gradient(180deg, #4254ff 0%, #63aafd 100%);
}

.sjjsbox {
  width: 440px;
  height: 350px;
  background: #ffffff;
  border-radius: 5px 5px 5px 5px;
  /* margin-bottom: 20px; */
  overflow: hidden;
}
.sjjsbox > h3 {
  height: 58px;
  text-align: left;
  text-indent: 2em;
  line-height: 58px;
  border-bottom: 1px #f1f5f6 solid;
  font-size: 19px;
  font-weight: bold;
  color: #1f216e;
  margin: 0;
  display: flex;
}
.sjjsbox > h3>span{
  display: block;
  width: 100px;
  height: 30px;
  color: #2c30b6;
  border-bottom: 1px  #000 soild;
  cursor: pointer;
  text-decoration:underline;
  margin-left: 180px;
}
.sjjsbox > div {
  overflow: hidden;
  margin-top: 16px;
  background: #f7fbfc;
}
.sjjsbox > div > p {
  width: 340px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  font-weight: 500;
  color: #676887;
  display: flex;
  /* justify-content: space-around; */
  margin: 0 auto;
}
.sjjsbox > div > p > .hy {
  display: block;
  width: 24px;
  height: 18px;
  text-align: left;
  margin-left: 80px;
}
.sjjsbox > div > p > .time {
  display: block;
  width: 24px;
  height: 18px;
  text-align: left;

}
.sjjsbox > div > div {
  margin-top: 5px;
  overflow: auto;
  width: 390px;
  height: 260px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
}
.sjjsbox > div > div > li {
  width: 340px;
  height: 30px;
  line-height: 30px;
  border-bottom: 1px #eff3f4 solid;
  margin: 0 auto;
  display: flex;
}
.sjjsbox > div > div > .portMsgcolor>span{
  color: #ff0000;
}
.sjjsbox > div > div > .portMsgcolor>.time{
  color: #ff0000;
}

.sjjsbox > div > div > .active > .time {
  display: block;
  width: 104px;
  font-size: 14px;
  font-weight: 400;
  color: #1f216e;
  line-height: 30px;
  text-align: left;
}
.sjjsbox > div > div > .active > span {
  display: block;
  width: 250px;
  font-size: 14px;
  font-weight: 400;
  color: #1f216e;
  line-height: 30px;
  text-align: left;
}
.sjjsbox > div > div > li > .time {
  display: block;
  width: 100px;
  text-align:left;
  font-size: 14px;
  font-weight: 400;
  color: #1f216ead;
  line-height: 30px;
  }
.sjjsbox > div > div > li > span {
  display: block;
  width: 200px;
  text-align:left;
  font-size: 14px;
  font-weight: 400;
  color: #1f216ead;
  line-height: 30px;
  }
  .sjjsbox > div > div > li > .time {
  display: block;
  width: 100px;
  text-align:left;
  font-size: 14px;
  font-weight: 400;
  color: #1f216ead;
  line-height: 30px;
  }
</style>
